import { PhonemeType } from "../../../generated/graphql";

/**
 * Phoneme types with human-readable labels
 * Used across phonics components for dropdowns, filters, and displays
 */
export const PHONEME_TYPES: { value: PhonemeType; label: string }[] = [
  { value: PhonemeType.Consonant, label: "Consonant" },
  { value: PhonemeType.ShortVowel, label: "Short Vowel" },
  { value: PhonemeType.LongVowel, label: "Long Vowel" },
  { value: PhonemeType.Digraph, label: "Digraph" },
  { value: PhonemeType.Trigraph, label: "Trigraph" },
  { value: PhonemeType.Blend, label: "Blend" },
  { value: PhonemeType.Diphthong, label: "Diphthong" },
  { value: PhonemeType.RControlled, label: "R-Controlled" },
  { value: PhonemeType.VowelTeam, label: "Vowel Team" },
  { value: PhonemeType.SilentLetter, label: "Silent Letter" },
  { value: PhonemeType.VariantVowel, label: "Variant Vowel" },
  { value: PhonemeType.Schwa, label: "Schwa" },
  { value: PhonemeType.SoftHard, label: "Soft/Hard" },
  { value: PhonemeType.SpecialPattern, label: "Special Pattern" },
  { value: PhonemeType.Other, label: "Other" },
];

/**
 * Map of phoneme type enum values to human-readable labels
 * Derived from PHONEME_TYPES to avoid duplication
 */
export const PHONEME_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  PHONEME_TYPES.map(({ value, label }) => [value, label])
);
